import  { z } from 'zod';

const DEFAULT_MESSAGE = 'Obrigatório';

export const formSchema = z.object({
  origin_uf: z
    .string({
      required_error: DEFAULT_MESSAGE,
    })
    .min(1, { message: DEFAULT_MESSAGE }),
  origin_ibge: z
    .string({
      required_error: DEFAULT_MESSAGE,
    })
    .min(1, { message: DEFAULT_MESSAGE }),
  destination_uf: z
    .string({
      required_error: DEFAULT_MESSAGE,
    })
    .min(1, { message: DEFAULT_MESSAGE }),
  destination_ibge: z
    .string({
      required_error: DEFAULT_MESSAGE,
    })
    .min(1, { message: DEFAULT_MESSAGE }),
  origin_lat: z
    .string({
      required_error: DEFAULT_MESSAGE,
    })
    .min(1, { message: DEFAULT_MESSAGE }),
  origin_lng: z
    .string({
      required_error: DEFAULT_MESSAGE,
    })
    .min(1, { message: DEFAULT_MESSAGE }),
  destination_lat: z
    .string({
      required_error: DEFAULT_MESSAGE,
    })
    .min(1, { message: DEFAULT_MESSAGE }),
  destination_lng: z
    .string({
      required_error: DEFAULT_MESSAGE,
    })
    .min(1, { message: DEFAULT_MESSAGE }),
});

export type FormSchema = z.infer<typeof formSchema>;